import axios from "axios";
import React, { useState,useEffect } from "react";
import { Card, Form, Row, Col, Button, Table,Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { handle401 } from "../../../utils/handleAuthError";

const BASE_URL = "https://sutmmg.codydeasoftech.in/api";

const SubDiv = () => {

    const [showModal, setShowModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [editId, setEditId] = useState(null);
    const [districts, setDistricts] = useState([]);
    const [subDivisions, setSubDivisions] = useState([]);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);


  const [filters, setFilters] = useState({
    searchKey: "",
    district_id: ""
  });

  const [formData, setFormData] = useState({
      district_id: "",
      sub_division_name: "",

    });


    const getAuthHeader = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  const fetchSubdivisionList = async (
  page = 1,
  searchValue = filters.searchKey,
  districtId = filters.district_id
) => {
  setLoading(true);

  try {
    const res = await axios.post(
      `${BASE_URL}/subDivisionList`,
      {
        searchKey: searchValue,
        district_id: districtId,   // ✅ ADD THIS
        page: page,
        per_page: perPage,
      },
      getAuthHeader()
    );

    setSubDivisions(res.data?.data || []);
    setPage(res.data.page || 1);
    setTotalRecords(res.data.total_records || 0);
    setTotalPages(
      Math.ceil((res.data.total_records || 0) / (res.data.per_page))
    );
  } catch (err) {
    if (handle401(err)) return;
    Swal.fire("warning", `${err.message}`, "warning");
  } finally {
    setLoading(false);
  }
};



    const navigate = useNavigate();


  const loadDistricts = async () => {
      try {
        const res = await axios.post(`${BASE_URL}/districtMasterList`,
          {}, getAuthHeader());
        setDistricts(res.data?.data || []);
      } catch (err) {
        console.error("District load error:", err);

        if (err.response?.status === 401) {
          Swal.fire("Session Expired", "Please login again", "warning");
          localStorage.clear();
          navigate("/suda/login");
        } else if (err.response?.status === 422) {
          Swal.fire(
            "Validation Failed",
            err.response.data?.message || "Invalid request",
            "warning"
          );
        } else {
          Swal.fire("Error!", "Failed to load districts", "error");
        }
      }
    };


const addSubDivision = async () => {
  try {
    const token = localStorage.getItem("token");

    // 🔥 Validation
    if (!formData.district_id || !formData.sub_division_name) {
      Swal.fire("Validation Error", "All fields are required", "warning");
      return;
    }

    const payload = {
      district_id: formData.district_id,
      sub_division_name: formData.sub_division_name,
      id: isEdit ? editId : ""
    };

    const res = await axios.post(
      `${BASE_URL}/subDivisionAddEdit`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data.status === true) {
      Swal.fire({
        icon: "success",
        title: isEdit ? "Updated Successfully" : "Added Successfully",
        text: res.data.message,
        timer: 1500,
        showConfirmButton: false,
      });

      setShowModal(false);
      setFormData({
        id:  editId,
        district_id: "",
        sub_division_name: "",
      });

fetchSubdivisionList(page, filters.searchKey, filters.district_id);
    } else {
      Swal.fire("Error", res.data.message, "error");
    }

  } catch (err) {
    console.error("Sub Division Error:", err);

    if (err.response?.status === 401) {
      Swal.fire("Session Expired", "Please login again", "warning");
      localStorage.clear();
      navigate("/suda/login");
    } else {
      Swal.fire(
        "Error",
        err.response?.data?.message || "Server error occurred",
        "error"
      );
    }
  }
};

const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };



    useEffect(() => {
        loadDistricts();
      }, []);


useEffect(() => {
  fetchSubdivisionList(1, filters.searchKey, filters.district_id);
}, [perPage]);


  const openAddModal = () => {
    setShowModal(true);
    setIsEdit(false);
    setEditId(null);
    setFormData({
      id: null,
      district_id: "",
      sub_division_name: "",
    });
  };


  const openEditModal = (row) => {
    setShowModal(true);
    setIsEdit(true);
    setEditId(row.id);
    setFormData({
      id: row.id,
      district_id: row.district_id,
      sub_division_name: row.sub_division_name,
    });
  };




  return (
    <div className="container mt-4" style={{ maxWidth: 1300 }}>

      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div
          className="px-4 py-3 text-white rounded-top"
          style={{
            background: "linear-gradient(90deg, #0D47A1, #1565C1)",
          }}
        >
          <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
            <i className="fa-solid fa-map"></i> Sub Division Master
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">Sub Division</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter subdivision name"
                  value={filters.searchKey}
                  onChange={(e) =>
                    setFilters({ ...filters, searchKey: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                />
              </Form.Group>
            </Col>


            <Col md={3}>
                          <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold text-dark">District</Form.Label>
                            <Form.Select
                              value={filters.district_id}
                              onChange={(e) =>
                                setFilters({ ...filters, district_id: e.target.value })
                              }
                              style={{
                                borderRadius: "10px",
                                border: "2px solid #1565C1",
                              }}
                            >
                              <option value="">Select District</option>
                              {districts.map((d) => (
                                <option value={d.id} key={d.id}>
                                  {d.name || d.district_name}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </Col>

            <Col md={3}>
                              <Form.Group className="mb-3">
                                              <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>

                                  <Form.Select
                                   style={{
                                                  borderRadius: "10px",
                                                  border: "2px solid #1565C1",
                                                }}
                                    value={perPage}
                                    onChange={(e) => {
                                      const value = Number(e.target.value);
                                      setPerPage(value);
                                      setPage(1);

                                    }}

                                  >
                                    <option value={10}>10 Per Page</option>
                                          <option value={25}>25 Per Page</option>
                                          <option value={50}>50 Per Page</option>
                                          <option value={100}>100 Per Page</option>
                                  </Form.Select>
                                  </Form.Group>
                              </Col>

                              {/* ✅ BUTTONS */}
                                    <Col md={4} className="d-flex gap-3 mt-3">
                                      {/* SEARCH */}
                                      <Button
                                        className="w-50 fw-semibold text-white"
                                        style={{
                                          background: "#1565C1",
                                          border: "none",
                                          borderRadius: "10px",
                                          transition: "0.3s",
                                        }}
                                        onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                                        onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
                                      onClick={() => fetchSubdivisionList(1, filters.searchKey)}
                                      >
                                        <i className="fa-solid fa-magnifying-glass me-2"></i> Search
                                      </Button>

                                      {/* RESET */}
                                      <Button
                                        className="w-50 fw-semibold text-white"
                                        style={{
                                          background: "#E53935",
                                          border: "none",
                                          borderRadius: "10px",
                                          transition: "0.3s",
                                        }}
                                        onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
                                        onMouseLeave={(e) => (e.target.style.background = "#E53935")}
                                        onClick={() => {
                                          setFilters({ searchKey: "",district_id: "" });
                                          setPage(1);
                                          setPerPage(10);
                                          fetchSubdivisionList(1,"","")

                                          }}
                                      >
                                        <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
                                      </Button>
                                    </Col>

          </Row>
        </Card.Body>
      </Card>


      <Button
              className="mb-3 px-4 text-white fw-semibold"
              onClick={openAddModal}
              style={{
                background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
                border: "none",
                borderRadius: "10px",
                padding: "10px 22px",
                boxShadow: "0 6px 15px rgba(46,125,50,0.4)",
                transition: "0.3s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background =
                  "linear-gradient(135deg, #1B5E20, #2E7D32)";
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 10px 22px rgba(46,125,50,0.55)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background =
                  "linear-gradient(135deg, #2E7D32, #66BB6A)";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 6px 15px rgba(46,125,50,0.4)";
              }}
            >
              <i className="fa-solid fa-circle-plus me-2"></i> Add Sub-Division
            </Button>

            {loading && (
        <div className="loader-wrapper">
            <div className="blue-spinner"></div>

            <div className="loading-line">
            <div className="loading-progress"></div>
            </div>

            <p className="loading-text">Loading, please wait...</p>
        </div>
        )}

      {/* 📄 TABLE (Same Style as SizeMaster) */}
      {!loading && (
        <>
        <Card
        className="border-0"
        style={{
          background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
          boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
          overflow: "hidden",
        }}
      >
        <Table bordered hover responsive striped>
          <thead>
            <tr>
              <th className="text-center" style={headerStyle}>SL No</th>
                            <th className="text-center" style={headerStyle}>Sub Division</th>

              <th className="text-center" style={headerStyle}>District</th>

              <th className="text-center" style={headerStyle}>Action</th>
            </tr>
          </thead>

          <tbody>
            {subDivisions.length > 0 ? (
              subDivisions.map((row, index) => (
                <tr key={row.id}>
<td className="text-center">
          {(page - 1) * perPage + index + 1}
        </td>                                    <td className="text-center">{row.sub_division_name}</td>

                  <td className="text-center">{row.district_name}</td>
                  <td className="text-center">
  <Button
    variant="warning"
    size="sm"
    className="d-flex align-items-center justify-content-center gap-2 mx-auto"
    style={{

      padding: "5px 14px",
      fontWeight: "600",
    }}
    onClick={() => openEditModal(row)}
  >
    <i className="fa-solid fa-pen-to-square"></i>
    Edit
  </Button>
</td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center text-muted py-4">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>


      </Card>

       {/* PAGINATION */}
    {totalPages > 1 && (
      <div className="d-flex justify-content-center mt-4">
        <nav>
          <ul className="pagination shadow-sm">
            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => fetchSubdivisionList(1)}>«</button>
            </li>

            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => fetchSubdivisionList(page - 1)}>‹</button>
            </li>

            {getPageNumbers().map((p) => (
              <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                <button className="page-link" onClick={() => fetchSubdivisionList(p)}>
                  {p}
                </button>
              </li>
            ))}

            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => fetchSubdivisionList(page + 1)}>›</button>
            </li>

            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => fetchSubdivisionList(totalPages)}>»</button>
            </li>
          </ul>
        </nav>
      </div>
    )}
        </>
      )}

      <Modal
  show={showModal}
  onHide={() => setShowModal(false)}
  centered
  size="md"
>
  <Modal.Header
    closeButton
    style={{ backgroundColor: "#1565C1", color: "white" }}
  >
    <Modal.Title>
      {isEdit ? "Edit Sub Division" : "Add Sub Division"}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Row>

      {/* DISTRICT */}
      <Col md={12}>
        <Form.Group className="mb-3">
          <Form.Label>
            District <span style={{ color: "red" }}>*</span>
          </Form.Label>

          <Form.Select
            value={formData.district_id}
            onChange={(e) =>
              setFormData({ ...formData, district_id: e.target.value })
            }
          >
            <option value="">Select District</option>
            {districts.map((d) => (
              <option key={d.id} value={d.id}>
                {d.district_name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>

      {/* SUB DIVISION NAME */}
      <Col md={12}>
        <Form.Group className="mb-3">
          <Form.Label>
            Sub Division Name <span style={{ color: "red" }}>*</span>
          </Form.Label>

          <Form.Control
            type="text"
            placeholder="Enter Sub Division Name"
            value={formData.sub_division_name}
            onChange={(e) =>
              setFormData({
                ...formData,
                sub_division_name: e.target.value,
              })
            }
          />
        </Form.Group>
      </Col>

    </Row>
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => setShowModal(false)}
    >
      Cancel
    </Button>

    <Button
      variant="success"
      className="text-white"
      onClick={addSubDivision}
    >
      {isEdit ? "Update" : "Submit"}
    </Button>
  </Modal.Footer>
</Modal>


    </div>
  );
};

const headerStyle = {
  padding: "10px",
  fontWeight: "600",
  backgroundColor: "#edf7fe",
  borderBottom: "1px solid black",
  borderTop: "1px solid black",
  textAlign: "center",
};

export default SubDiv;
